import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const ClientsView = () => {
  const params = useParams();
  const navigate = useNavigate();
  const clientId = params.data || params.id; // supports /clientsView/:id or :data

  const [rowData, setRowData] = useState({
    id: "",
    name: "",
    domain: "",
    redirect_url: "",
    email: "",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clientId) return;
    fetch(`${process.env.REACT_APP_API_URL}/clients/${clientId}`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFkbWluQGF1dGhmYXN0LmNvbSIsImlkIjo1LCJ1c2VyVHlwZSI6InN1cGVyYWRtaW4iLCJpYXQiOjE2NjM2NTE2NzV9.raQf8JTVyiM51zg6OgH1RLkQqK_QyGPO2rJa9-oYDko",
      }),
    })
      .then((r) => r.json())
      .then((res) => {
        setRowData(res?.data || {});
      })
      .finally(() => setLoading(false));
  }, [clientId]);

  return (
    <div className="max-h-full bg-gray-50">
      {/* Top bar with title + back */}
    {/* Top bar with centered title + left back */}
<div className="w-full border-b flex  items-center px-4 py-3  shadow-sm">
  {/* <div className="mx-auto px-4 py-3 "> */}
    {/* Back button on the left */}
    <button
      onClick={() => navigate(-1)}
      className="gap-2 rounded-md px-3 py-1.5 text-sm font-medium"
    >
      ← Back
    </button>

    {/* Centered title */}
    <h1 className="text-lg md:text-xl font-semibold  uppercase">
      View {loading ? "..." : rowData?.name || "Client"} Details
    </h1>
  {/* </div> */}
</div>


      {/* Content */}
      <div className="max-w-5xl mx-auto px-4 py-6">
        <div className="flex justify-center">
          <div className="w-full max-w-lg">
            <div className="rounded-2xl bg-white shadow-md ring-1 ring-black/5">
              <div className="px-6 py-5 border-b">
                <h2 className="text-xl font-semibold text-gray-900 uppercase">
                  {loading ? "Loading…" : rowData?.name || "Client"}
                </h2>
                <p className="text-sm text-gray-500">Client ID: {rowData?.id ?? "-"}</p>
              </div>

              <div className="px-6 py-5 space-y-4">
                <div className="flex items-start justify-between">
                  <span className="text-sm text-gray-600">Name</span>
                  <span className="text-sm font-medium text-gray-900">{rowData?.name || "-"}</span>
                </div>
                <div className="flex items-start justify-between">
                  <span className="text-sm text-gray-600">Domain</span>
                  <a
                    href={rowData?.domain}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm font-medium text-blue-600 hover:underline break-all text-right max-w-[70%]"
                  >
                    {rowData?.domain || "-"}
                  </a>
                </div>
                <div className="flex items-start justify-between">
                  <span className="text-sm text-gray-600">Redirect URL</span>
                  <a
                    href={rowData?.redirect_url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm font-medium text-blue-600 hover:underline break-all text-right max-w-[70%]"
                  >
                    {rowData?.redirect_url || "-"}
                  </a>
                </div>
                <div className="flex items-start justify-between">
                  <span className="text-sm text-gray-600">Email</span>
                  <span className="text-sm font-medium text-gray-900 break-all text-right max-w-[70%]">
                    {rowData?.email || "-"}
                  </span>
                </div>
              </div>
            </div>

            {/* Optional helper text */}
            {!loading && !rowData?.id && (
              <p className="mt-4 text-sm text-red-600 text-center">
                Could not load client details. Please check the URL or try again.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientsView;
